import { render, staticRenderFns } from "./homefire-policy-detail-info.vue?vue&type=template&id=5fd2b896&scoped=true&"
import script from "./homefire-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./homefire-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./homefire-policy-detail-info.vue?vue&type=style&index=0&id=5fd2b896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2b896",
  null
  
)

export default component.exports